import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { getGoogleAnalyticsClientId } from "~/components/tracking/google-analytics/apis";
import { accountAtom } from "~/lib/account";

import { syncMirrorGAUserIds } from ".";

export function useMirrorTrackPageLoad() {
  const { user } = useAtomValue(accountAtom);

  useEffect(() => {
    const run = async () => {
      const gaClientId = await getGoogleAnalyticsClientId();

      if (!gaClientId) return;

      syncMirrorGAUserIds(gaClientId);
    };
    void run();
  }, [user]);
}
